<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted () {
    const script = document.createElement('script')
    script.src = 'https://v1.cnzz.com/z_stat.php?id=1280110491&web_id=1280110491'
    script.language = 'JavaScript'
    document.body.appendChild(script)
  },
  watch: {
    '$route' () {
      if (window._czc) {
        let location = window.location
        let contentUrl = location.pathname + location.hash
        let refererUrl = '/'
        window._czc.push(['_trackPageview', contentUrl, refererUrl])
      }
    }
  },
}
</script>

<style>
body {
  margin: auto;
  /* max-width: 1920px;
  min-width: 1200px; */
  background-color: #fbfdfb;
}
button, input {
  margin: 0;
  padding: 0;
  border: 0;
  background: transparent;
  outline: none;
}
a {
  text-decoration: none;
}
#app {}
.modal-mask {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0,0,0,0.4);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 11;
}
.modal-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  margin-bottom: 20px;
  padding: 0 8px;
  width: 240px;
  height: 220px;
  background-color: #fff;
  border-radius: 12px;
}
.image-preview-box {
  position: relative;
  padding: 10px;
  width: 500px;
  background-color: #fff;
  border-radius: 6px;
}
.image-preview-box img {
  width: 100%;
  border-radius: 5px;
}
.image-preview-box-close {
  position: absolute;
  top: 0;
  right: 0;
}
.modal-close {
  position: absolute;
  top: 0;
  left: 0;
  margin: 9px 12px;
}
.modal-avatar {
  position: absolute;
  top: -12px;
  left: 96px;
  height: 66px;
  width: 66px;
  border-radius: 50%;
}
.modal-title {
  margin-top: 16px;
  font-size: 16px;
  font-weight: 500;
  color: #333;
  text-align: center;
}
.modal-content {
  margin: 0;
  font-size: 12px;
  line-height: 20px;
  color: #999999;
  text-align: center;
}
.modal-btn {
  width: 210px;
  height: 27px;
  text-align: center;
  line-height: 28px;
  border-radius: 20px;
  display: block;
  margin: 0;
  color: #fff;
  font-weight: 500;
  font-size: 12px;
  background: #0BA09A;
}

.toast {
  width: 120px;
  margin: 0 10px;
  position: fixed;
  top: 50%;
  left: 50%;
  color: #fff;
  font-size: 12px;
  line-height: 26px;
  background: rgba(0, 0, 0, 0.6);
  text-align: center;
  border-radius: 6px;
}
.common-padding {
  padding: 50px 0 80px 0;
}
.common-padding2 {
  padding: 24px 16% 40px 16%;
}
.title {
  font-size: 30px;
  color: #283B5E;
  font-weight: 600;
  line-height: 65px;
}

.describe {
  font-size: 15px;
  line-height: 30px;
  color: #666666;
}
.tag {
  /* float: left; */
  width: 90px;
  border: 1px solid #0BA09A;
  font-size: 14px;
  font-weight: 600;
  line-height: 24px;
  color: #0BA09A;
  text-align: center;
}
.button {
  background-color: #0BA09A; 
  font-size: 14px;
  line-height: 32px;
  color: #ffffff;
  text-align: center;
}

.main-color { color: #0BA09A; }
.white-color { color: #ffffff; }
.red-color { color: #F06067; }
.black-color { color: #283B5E; }
.gray-color { color: #666666; }
.main-bg { background-color: #0BA09A; }
.white-bg { background-color: #ffffff; }
.warp-bg { background-color: #F5FBF9; }

.fs10 { font-size: 10px; }
.fs12 { font-size: 12px; }
.fs13 { font-size: 13px; }
.fs14 { font-size: 14px; }
.fs16 { font-size: 16px; }
.fs17 { font-size: 17px; }
.fs18 { font-size: 18px; }
.fs20 { font-size: 20px; }
.fs22 { font-size: 22px; }
.fw500 { font-weight: 500; }
.lh2 { line-height: 2; }

.fw600{ font-weight: 600}

.ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.ellipsis2 {
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}
.ellipsis3 {
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
}

.cp {
  cursor: pointer;
}

.flex{
  display: flex;
}
.fww{
  flex-wrap: wrap;
}
.fxdc{
  flex-direction: column;
}
.fg0{
  flex-grow: 0;
}
.jcsb{
  justify-content: space-between;
}
.jcc{
  justify-content: center;
}
.jcs{
  justify-content: flex-start;
}
.jce{
  justify-content: flex-end;
}
.jcsa{
  justify-content: space-around;
}
.aifs {
  align-items: flex-start;
}
.aic{
  align-items: center;
}
.aib{
  align-items: baseline;
}
.ais{
  align-items: stretch;
}
.tac {
  text-align: center;
}
.banner-swiper .swiper-pagination-bullet {
  width: 27px;
  height: 6px;
  background: #FFFFFF;
  opacity: 0.1;
  border-radius: 3px;
}
.banner-swiper .swiper-pagination-bullet-active {
  opacity: 1;
}
.evaluate-wrap .swiper-pagination{
  bottom:0px
}
.evaluate-wrap .swiper-pagination-bullet {
  width: 16px;
  height: 16px;
  background: #FFFFFF;
  border: 2px solid #0BA09A;
  border-radius: 50%;
  opacity: 0.1;
}
.evaluate-wrap .swiper-pagination-bullet-active {
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/App.vue